import { render, staticRenderFns } from "./BookingReviewTable.vue?vue&type=template&id=3e28e080&scoped=true"
import script from "./BookingReviewTable.vue?vue&type=script&lang=js"
export * from "./BookingReviewTable.vue?vue&type=script&lang=js"
import style0 from "./BookingReviewTable.vue?vue&type=style&index=0&id=3e28e080&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e28e080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e28e080')) {
      api.createRecord('3e28e080', component.options)
    } else {
      api.reload('3e28e080', component.options)
    }
    module.hot.accept("./BookingReviewTable.vue?vue&type=template&id=3e28e080&scoped=true", function () {
      api.rerender('3e28e080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/booking/BookingReviewTable.vue"
export default component.exports